export function getParabolaABC(x1,y1,x2,y2,x3,y3) {
    let a = (y3 - (x3*(y2-y1) + x2*y1-x1*y2)/(x2-x1))/(x3*(x3-x1-x2)+x1*x2)
    let b = (y2-y1)/(x2-x1) - a*(x1+x2);
    let c = (x2*y1 - x1*y2) / (x2-x1) + a*x1*x2;

    return {a,b,c};
}

export function calculateDistance(position1, position2) {
    return Math.sqrt(Math.pow(position1.Top - position2.Top,2)+Math.pow(position1.Left - position2.Left,2));
}

export function randomInteger(min, max) {
    var rand = min - 0.5 + window.rand() * (max - min + 1)
    rand = Math.round(rand);
    return rand;
  }

export function delay(time) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, time)
    });
}

export function calculateColor(fatigue) {
    if(fatigue ==0)
        return '#008000';
    if(fatigue == 1)
        return '#0bba0b';
    if(fatigue == 2)
        return '#ADFF2F';
    if(fatigue == 3)
        return '#FFD700';
    if(fatigue == 4)
        return '#DAA520';
    if(fatigue == 5)
        return '#8B0000';
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/helper.js
 **/